import { color, getContrastingColor } from "@uiw/color-convert";
import Swatch from "@uiw/react-color-swatch";

import * as colors from "@mui/material/colors";
import Box from "@mui/material/Box";
import { colorDifference } from "./colorUtils";

// Mimic the interface of react-color's SwatchesPicker.
// That package is abandoned and does not support newer versions of React.

function Checked(props) {
  if (!props.checked) {
    return null;
  }

  const unicodeCheckbox = "\u2714";

  return (
    <div
      style={{
        fontSize: "0.9rem",
        textAlign: "center",
        verticalAlign: "middle",
        color: getContrastingColor(props.color),
      }}
    >
      {unicodeCheckbox}
    </div>
  );
}

function makeColorObject(hsva) {
  // Mimic the old color picker by returning an object that has
  // the same properties and values it had.
  const rawColor = color(hsva);

  const colorObj = {
    hsl: rawColor.hsl,
    hex: rawColor.hex,
    rgb: rawColor.rgb,
    hsv: rawColor.hsv,
  };

  colorObj.hsl.s /= 100;
  colorObj.hsl.l /= 100;

  colorObj.hsv.s /= 100;
  colorObj.hsv.v /= 100;

  colorObj.hsl.a = 1;
  colorObj.rgb.a = 1;
  colorObj.hsv.a = 1;

  colorObj.source = "hex";

  return colorObj;
}

function findClosestColorMatch(color, colorsList) {
  let bestColorMatch = null;
  let bestColorMatchScore = Infinity;

  for (let candidateColor of colorsList) {
    const score = colorDifference(color, candidateColor);
    if (score < bestColorMatchScore) {
      bestColorMatch = candidateColor;
      bestColorMatchScore = score;
    }
  }

  return bestColorMatch;
}

export default function SwatchesPicker({ color, onChangeComplete }) {
  // Got this list from the react-color SwatchesPicker source.
  // prettier-ignore
  const colorsList = [
    colors.red['900'], colors.red['700'], colors.red['500'], colors.red['300'], colors.red['100'],
    colors.pink['900'], colors.pink['700'], colors.pink['500'], colors.pink['300'], colors.pink['100'],
    colors.purple['900'], colors.purple['700'], colors.purple['500'], colors.purple['300'], colors.purple['100'],
    colors.deepPurple['900'], colors.deepPurple['700'], colors.deepPurple['500'], colors.deepPurple['300'], colors.deepPurple['100'],
    colors.indigo['900'], colors.indigo['700'], colors.indigo['500'], colors.indigo['300'], colors.indigo['100'],
    colors.blue['900'], colors.blue['700'], colors.blue['500'], colors.blue['300'], colors.blue['100'],
    colors.lightBlue['900'], colors.lightBlue['700'], colors.lightBlue['500'], colors.lightBlue['300'], colors.lightBlue['100'],
    colors.cyan['900'], colors.cyan['700'], colors.cyan['500'], colors.cyan['300'], colors.cyan['100'],
    colors.teal['900'], colors.teal['700'], colors.teal['500'], colors.teal['300'], colors.teal['100'],
    colors.green['900'], colors.green['700'], colors.green['500'], colors.green['300'], colors.green['100'],
    colors.lightGreen['900'], colors.lightGreen['700'], colors.lightGreen['500'], colors.lightGreen['300'], colors.lightGreen['100'],
    colors.lime['900'], colors.lime['700'], colors.lime['500'], colors.lime['300'], colors.lime['100'],
    colors.yellow['900'], colors.yellow['700'], colors.yellow['500'], colors.yellow['300'], colors.yellow['100'],
    colors.amber['900'], colors.amber['700'], colors.amber['500'], colors.amber['300'], colors.amber['100'],
    colors.orange['900'], colors.orange['700'], colors.orange['500'], colors.orange['300'], colors.orange['100'],
    colors.deepOrange['900'], colors.deepOrange['700'], colors.deepOrange['500'], colors.deepOrange['300'], colors.deepOrange['100'],
    colors.brown['900'], colors.brown['700'], colors.brown['500'], colors.brown['300'], colors.brown['100'],
    colors.blueGrey['900'], colors.blueGrey['700'], colors.blueGrey['500'], colors.blueGrey['300'], colors.blueGrey['100'],
    '#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF'
  ];

  // We might get a string or we might get an object like we return ourselves.
  // The component we use can't handle a color object so here we turn it
  // into a hex string.
  let initialColor = color;
  if (typeof initialColor != "string") {
    if (color.hex) {
      initialColor = color.hex;
    }
  }

  // Find the closest match so "some" box is always checked.
  initialColor = findClosestColorMatch(initialColor, colorsList);

  return (
    // Since we can't make this look the same as before, we try to have each row contain
    // 5 colors to mimic the "groupings of 5" from the old component.
    <Box
      sx={{
        paddingTop: "10px",
        paddingLeft: "13px",
        paddingRight: "0px",
        maxWidth: "295px",
      }}
    >
      <Swatch
        color={initialColor}
        colors={colorsList}
        onChange={(color) => onChangeComplete(makeColorObject(color))}
        rectProps={{
          children: <Checked />,
          style: {
            height: "20px",
            width: "50px",
            border: "1px solid rgba(0, 0, 0, 0.1)",
          },
        }}
      />
    </Box>
  );
}
